module.exports = __webpack_public_path__ + "science.wet-and-dry.dot.wet.png?495c17776fa01780da34f2e702625bde";